
const DotIcon = ({ color = "#0152FB" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="3" fill={color} />
        </svg>
    )
}

export default DotIcon